export default __webpack_public_path__ + "static/media/allow-withdraw-1-desktop.24b64e29.png";